@if (isUpdating$ | async) {
  <cx-spinner class="overlay"></cx-spinner>
}
<div class="row reset-password-container">
  <div class="header-group col-sm-12 col-lg-6">
    <h2 class="title">{{ 'forgottenPassword.title' | cxTranslate }}</h2>
    <p class="subtitle">{{ 'forgottenPassword.subtitle' | cxTranslate }}</p>
  </div>
</div>
<div class="row reset-password-container">
  <div class="col-sm-12 col-lg-6 ">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <label>
        <span class="label-content">{{ 'forgottenPassword.emailAddress.label' | cxTranslate }}</span>
        <input
          type="email"
          class="form-control"
          placeholder="{{ 'forgottenPassword.emailAddress.placeholder' | cxTranslate }}"
          formControlName="userEmail"
          />
        <cx-form-errors [control]="form.get('userEmail')"></cx-form-errors>
      </label>
      <button class="btn btn-black btn-block" [disabled]="form.disabled">
        {{ 'common.submit' | cxTranslate }}
      </button>
      <div class="btn-reset-password-container">
        <a class="reset-password" (click)="back()">
          {{ 'common.back' | cxTranslate }}
        </a>
      </div>
    </form>
  </div>
</div>
